/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Breadcrumb, Card, Input, Segmented, message, Alert } from 'antd';
import {
	CheckCircleOutlined,
	CarOutlined,
	PlayCircleOutlined,
	RadarChartOutlined,
	LoadingOutlined,
} from '@ant-design/icons';

import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { style } from '../../Styles';
import DriverCard from './DriverCard';
import { getRandomGoogleMapsKey } from '../../redux/googleMapsKeySlice';
import GodsViewMap from './GodsViewMap';
import useSSE from '../../CustomHooks/useSSE';
import './style.css';

const { Search } = Input;
const endpoint = 'gods-view';
const eventListener = 'gods-view-event';

const GodsView = () => {
	const location = useLocation();

	const [selectedStatus, setSelectedStatus] = useState(location?.state?.selectedOption || 'ALL');
	const { data, connectionState, retryCount } = useSSE(
		`${endpoint}?status=${selectedStatus}`,
		eventListener,
	);
	const [filter, setfilter] = useState('');
	const [selectedDriver, setSelectedDriver] = useState(null);
	const [zoom, setZoom] = useState(7);

	const dispatch = useDispatch();

	const fetchGoogleMapsKey = () => {
		dispatch(getRandomGoogleMapsKey())
			.then(() => {})
			.catch(() => {
				message.error('Error getting google maps key');
			});
	};

	const filtredData = data?.filter((item) => {
		return (
			item.user.name.toString().toLowerCase().indexOf(filter.toLowerCase()) !== -1 ||
			item.user.surname.toString().toLowerCase().indexOf(filter.toLowerCase()) !== -1 ||
			item.user.email.toString().toLowerCase().indexOf(filter.toLowerCase()) !== -1
		);
	});
	useEffect(() => {
		fetchGoogleMapsKey();
	}, [dispatch]);

	// Render connection status for debugging
	const renderConnectionStatus = () => {
		switch (connectionState) {
			case 'connecting':
				return (
					<Alert
						message='Connecting to live data...'
						type='info'
						showIcon
						icon={<LoadingOutlined />}
						style={{ marginBottom: 16 }}
					/>
				);
			case 'error':
			case 'timeout':
				return (
					<Alert
						message={`Connection issue - Retrying (${retryCount}/5)`}
						type='warning'
						showIcon
						style={{ marginBottom: 16 }}
					/>
				);
			case 'max-retries-reached':
				return (
					<Alert
						message='Unable to connect to live data. Please refresh the page.'
						type='error'
						showIcon
						style={{ marginBottom: 16 }}
					/>
				);
			case 'no-auth':
				return (
					<Alert
						message='Authentication required. Please log in again.'
						type='error'
						showIcon
						style={{ marginBottom: 16 }}
					/>
				);
			case 'parse-error':
				return (
					<Alert
						message='Data parsing error. Please refresh the page.'
						type='error'
						showIcon
						style={{ marginBottom: 16 }}
					/>
				);
			default:
				return null;
		}
	};

	return (
		<Card style={{ margin: 16, height: '90vh' }}>
			{renderConnectionStatus()}
			<div style={style.inlineContent}>
				<div
					style={{
						display: 'flex',
						alignContent: 'center',
						alignItems: 'center',
						marginBottom: 8,
					}}>
					<Breadcrumb
						style={{ margin: '0 1em 0 0', fontSize: '1.1em' }} // Adjust margin as needed
						items={[
							{
								title: "God's View",
							},
						]}
					/>
				</div>
				<div
					style={{
						...style.inlineContent,
						marginBottom: 8,
					}}>
					<Segmented
						defaultValue={selectedStatus}
						size='middle'
						onChange={(e) => {
							setfilter('');
							setSelectedDriver(null);
							setSelectedStatus(e);
						}}
						options={[
							{
								label: 'Enroute to pickup',
								value: 'ENROUTE_TO_PICKUP',
								icon: <CarOutlined />,
							},
							{
								label: 'Booking started',
								value: 'BOOKING_STARTED',
								icon: <PlayCircleOutlined />,
							},
							{
								label: 'Online',
								value: 'AVAILABLE',
								icon: <CheckCircleOutlined />,
							},
							{
								label: 'All (only those with location)',
								value: 'ALL',
								icon: <RadarChartOutlined />,
							},
						]}
					/>
				</div>
			</div>
			<Card style={{ height: '100%', width: '100%' }} bordered={false}>
				<Card.Grid style={{ width: '25%', height: '73vh' }}>
					<div
						style={{
							height: '100%',
							width: '100%',
							overflow: 'auto',
							maxHeight: '100%',
						}}>
						<Search
							placeholder='Search'
							onChange={(e) => setfilter(e.target.value)}
							style={{ width: '100%' }}
							allowClear
						/>

						{filtredData?.map((driver) => (
							<DriverCard
								key={driver.user.id}
								zoom={zoom}
								setZoom={setZoom}
								driver={driver}
								setSelectedDriver={setSelectedDriver}
								width='96%'
							/>
						))}
					</div>
				</Card.Grid>
				<Card.Grid style={{ width: '75%', height: '73vh' }}>
					<div style={{ height: '100%', width: '100%' }}>
						<GodsViewMap
							zoom={zoom}
							setZoom={setZoom}
							drivers={filtredData || []}
							selectedDriver={selectedDriver}
							setSelectedDriver={setSelectedDriver}
						/>
					</div>
				</Card.Grid>
			</Card>
		</Card>
	);
};

export default GodsView;
